module.exports = __webpack_public_path__ + "static/media/fire.08d201a5.svg";